const SIDEBAR_CHAT_TEXTAREA_SELECTOR = '[data-sidebar="sidebar"] textarea[data-chat-input="true"]';

/**
 * Focuses the sidebar chat input with the caret at the end. Runs a tick later so a sidebar
 * that was just opened has mounted the input; does nothing if there is no chat input.
 */
export function focusSidebarChatInput(): void {
  setTimeout(() => {
    const textarea = document.querySelector(
      SIDEBAR_CHAT_TEXTAREA_SELECTOR,
    ) as HTMLTextAreaElement | null;
    if (!textarea) {
      return;
    }

    textarea.focus();
    const end = textarea.value.length;
    textarea.setSelectionRange(end, end);
    textarea.scrollTop = textarea.scrollHeight;
  }, 10);
}
